import NotificationItem from './NotificationItem';
import { useGetNotifications } from 'services/notifications/hook';
import Loader from 'components/Loader';
import { LoadMoreButton } from 'components/LoadMoreButton';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import NoNotification from './NoNotification';

export default function UnreadNotifications() {
  const { inView } = useInView();

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isFetching } =
    useGetNotifications({
      status: 'unread',
    });

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, isFetching]);

  if (isFetching) {
    return <Loader />;
  }

  return (
    <div className='space-y-4'>
      {data?.data && data?.data?.length ? (
        data?.data?.map((notification, index) => (
          <NotificationItem
            item={notification}
            key={`${notification.category}-${index}`}
          />
        ))
      ) : (
        <NoNotification />
      )}

      <div>
        {hasNextPage && !isFetchingNextPage ? (
          <LoadMoreButton
            onClick={() => fetchNextPage()}
            className='border-t-0'
          />
        ) : isFetchingNextPage ? (
          <Loader className='h-12' loaderSize='size-6' />
        ) : null}
      </div>
    </div>
  );
}
